var React = require('react');

function XShape (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m3.60783 4.00008-2.854844-2.85485c-.261499-.261495.130749-.653743.392244-.392244l2.85485 2.854844 2.85485-2.854844c.2615-.261499.65375.130749.39225.392244l-2.85485 2.85485 2.85485 2.85485c.2615.2615-.13075.65375-.39225.39225l-2.85485-2.85485-2.85485 2.85485c-.261495.2615-.653743-.13075-.392244-.39225z","fill":"#222","fillRule":"evenodd","stroke":"#222","strokeWidth":".8"}));
}

XShape.defaultProps = {"fill":"none","height":"8","viewBox":"0 0 8 8","width":"8"};

module.exports = XShape;

XShape.default = XShape;
